/**
 * Cart reservation countdown — persists across cart drawer section re-renders via localStorage.
 */
(function () {
  const STORAGE_DEADLINE = 'icon-cart-reservation-deadline';
  const STORAGE_CONFIG = 'icon-cart-reservation-config';

  function refreshAllTimers() {
    document.querySelectorAll('cart-reservation-timer').forEach((el) => {
      if (el.isConnected) el.refresh();
    });
  }

  class CartReservationTimer extends HTMLElement {
    connectedCallback() {
      this._label = this.querySelector('.cart-reservation-timer__label') || this;
      this._durationMinutes = parseInt(this.dataset.durationMinutes, 10) || 10;
      this._durationMs = this._durationMinutes * 60 * 1000;
      this._textTemplate =
        this.dataset.text || 'YOUR ORDER IS RESERVED FOR [[timer]]';

      this._syncConfig();
      this._deadline = this._readOrCreateDeadline();

      this.refresh();
      clearInterval(this._interval);
      this._interval = setInterval(() => this.refresh(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    refresh() {
      const remaining = this._deadline - Date.now();

      if (remaining <= 0) {
        this._resetDeadline();
        this.refresh();
        return;
      }

      const time = this._formatTime(remaining);
      const text = this._textTemplate.includes('[[timer]]')
        ? this._textTemplate.replace(/\[\[timer\]\]/g, time)
        : `${this._textTemplate.trim()} ${time}`;

      this._label.textContent = text;
    }

    _configKey() {
      return String(this._durationMinutes);
    }

    _syncConfig() {
      const key = this._configKey();
      if (localStorage.getItem(STORAGE_CONFIG) !== key) {
        localStorage.setItem(STORAGE_CONFIG, key);
        localStorage.removeItem(STORAGE_DEADLINE);
      }
    }

    _readOrCreateDeadline() {
      const stored = parseInt(localStorage.getItem(STORAGE_DEADLINE), 10);
      const now = Date.now();
      if (stored && stored > now) return stored;
      const deadline = now + this._durationMs;
      localStorage.setItem(STORAGE_DEADLINE, String(deadline));
      return deadline;
    }

    _resetDeadline() {
      this._deadline = Date.now() + this._durationMs;
      localStorage.setItem(STORAGE_DEADLINE, String(this._deadline));
    }

    _formatTime(ms) {
      const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  }

  if (!window.customElements.get('cart-reservation-timer')) {
    window.customElements.define('cart-reservation-timer', CartReservationTimer);

    document.addEventListener('cart:change', () => {
      requestAnimationFrame(refreshAllTimers);
    });
    document.addEventListener('cart:refresh', () => {
      requestAnimationFrame(refreshAllTimers);
    });
  }
})();
